import { render, staticRenderFns } from "./ProjectReport.vue?vue&type=template&id=ef9dd6ee&scoped=true"
import script from "./ProjectReport.vue?vue&type=script&lang=js"
export * from "./ProjectReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9dd6ee",
  null
  
)

export default component.exports